/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input, Text } from '@/lib/v2/components';

import Header from './Header';

interface GetCodeProps {
  onConfirm: (token: string) => void;
  onResendCode: () => void;
  onChangePhone?: () => void;
  onSkip: () => void;
  canSkip?: boolean;
  isLoading?: boolean;
}

const GetCode = ({ onConfirm, onResendCode, canSkip, onSkip, isLoading }: GetCodeProps) => {
  const { t } = useTranslation();

  // 1. Use the useState hook to manage the input value
  const [token, setToken] = useState('');

  return (
    <div className="flex w-full flex-col items-center gap-8">
      <Header
        description={t('AUTH.TWO_AUTHENTICATE.get_code_description')}
        title={t('AUTH.TWO_AUTHENTICATE.two_step')}
      />

      {/* 2. Assign a value prop and an onChange prop to the Input */}
      <Input
        label={t('AUTH.TWO_AUTHENTICATE.code')}
        placeHolder={t('AUTH.TWO_AUTHENTICATE.codePlaceholder')}
        type="number"
        value={token}
        onChange={(e) => setToken(e.target.value)}
      />

      <div className="flex w-full flex-col items-center gap-4">
        {/* 3. Pass the value from the state to the onConfirm method */}
        <Button fullWidth isLoading={isLoading} onClick={() => onConfirm(token)}>
          {t('AUTH.TWO_AUTHENTICATE.confirm')}
        </Button>
        <div className="flex w-full flex-col items-center gap-2">
          <Text color="primary" fontWeight="medium" variant="text" onClick={onResendCode}>
            {t('AUTH.TWO_AUTHENTICATE.resendCode')}
          </Text>
          {canSkip && (
            <Button fullWidth onClick={onSkip}>
              {t('AUTH.TWO_AUTHENTICATE.skip')}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default GetCode;
